import React from "react";
import {connect} from "react-redux";
import {
    acknowledgeAttendance, acknowledgeCompleteAttendance,
    actionGetPendingAcknowledgeAttendanceList, setSelectedAttendance
} from "../../../../../actions/admin/attendance.actions";
import DataTable from "react-data-table-component";
import {calculateTimeDiff, convertDateTimeToCustomFormat} from "../../../../../utlis";
import {userConstants} from "../../../../../constants";
import Badge from "react-bootstrap/Badge";
import {
    AttendanceAcknowledgment
} from "../../../shared/attendance/attendance-acknowledgement";

class AttendancePendingAckApprovals extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showAttendanceAcknowledgeModal: false,
        };
    }

    componentDidMount() {
        this.props.actionGetPendingAcknowledgeAttendanceList();
    }

    renderColumns = () => {
        const {lang} = this.props;
        return [
            {
                name: lang.Name,
                sortable: true,
                selector: 'user.firstName',
                cell: row => row.user.firstName + ' ' + row.user.lastName
            },
            {
                name: lang.Outlet,
                sortable: true,
                selector: 'outlet.name',
                cell: row => row.outlet?.name
            },
            {
                name: lang.PunchInTime,
                sortable: true,
                selector: 'punchInDateTime',
                cell: row => convertDateTimeToCustomFormat(row.punchInDateTime)
            },
            {
                name: lang.PunchOutTime,
                sortable: true,
                selector: 'punchOutDateTime',
                cell: row => (
                    row.punchOutDateTime ? convertDateTimeToCustomFormat(row.punchOutDateTime) : '-saqi'
                )
            },
            {
                name: lang.Status,
                selector: 'status',
                sortable: true,
                cell: row => (
                    <h6>
                        {row.status === userConstants.PUNCH_IN && <Badge variant="success">{lang.PunchedIn}</Badge>}
                        {row.status === userConstants.PUNCH_OUT && <Badge variant="light">{lang.PunchedOut}</Badge>}
                        {row.status === userConstants.BREAK_START && <Badge variant="warning">{lang.OnBreak}</Badge>}
                    </h6>
                )
            },
            {
                name: lang.TotalHours,
                sortable: true,
                cell: row => {
                    const endTime = row.punchOutDateTime ? row.punchOutDateTime : (new Date()).toISOString();
                    return calculateTimeDiff(endTime, row.punchInDateTime)
                }
            },
            {
                name: lang.Actions
            }

        ]
    };
    handleClosing = () => {
        this.setState({showAttendanceAcknowledgeModal: false})
        this.props.actionGetPendingAcknowledgeAttendanceList()
    }
    render() {
        const {lang, attendanceList, selectedAttendance} = this.props;
        const {showAttendanceAcknowledgeModal} = this.state;
        return (
            <div className="pt-3">
                <DataTable
                    title={lang.Attendance}
                    columns={this.renderColumns()}
                    data={attendanceList}
                    pagination={true}
                    highlightOnHover
                    pointerOnHover
                    onRowClicked={(row) => {
                        this.props.setSelectedAttendance(row);
                        this.setState({showAttendanceAcknowledgeModal: true})
                    }}
                    defaultSortAsc="false"
                    responsive="true"
                />
                <AttendanceAcknowledgment
                    attendance={selectedAttendance}
                    showModal={showAttendanceAcknowledgeModal}
                    handleModalClose={() => 
                        this.handleClosing()}
                    canAcknowledge={true}
                    handleSubmitAcknowledgement={this.props.acknowledgeAttendance}
                    handleBulkAcknowledgement={this.props.acknowledgeCompleteAttendance}
                    lang={lang}/>
            </div>
        );
    }
}

const mapStateToProps = ({langReducer, admin: {attendanceReducer}}) => ({
    lang: langReducer.lang,
    attendanceList: attendanceReducer.Ack_AttendanceRecords,
    selectedAttendance: attendanceReducer.selectedAttendance
});

export default connect(mapStateToProps, ({
    actionGetPendingAcknowledgeAttendanceList,
    acknowledgeAttendance,
    acknowledgeCompleteAttendance,
    setSelectedAttendance
}))(AttendancePendingAckApprovals);
